<template>
<div class="k-page-content">
	<div class="messageIndex">
		<div class="left box">
			<div class="title">
				<span class="t1">消息</span>
				<!-- <span class="t2" @click="readAll()">一键已读 <i class="el-icon-thumb"></i></span> -->
			</div>
			<div class="fenlei">
				<span>分类</span>
				<el-button
				      v-for="(btn, index) in buttons"
				      :key="index"
				      :type="getButtonType(index)"
				      :plain="isButtonPlain(index)"
				      @click="toggleButton(index)"
				      size="mini"
				      round
				    >
				      {{ btn.text }}
				    </el-button>
			</div>
			<ul class="con" v-if="tableData.data.length > 0">
				<li v-for="(item,index) in tableData.data" :key="index" @click="getDetail(item)">
					<div :class="item.send_name_jian == '系统' ? 'name two' : 'name'">{{item.send_name_jian}}</div>
					<div class="content">
						<span class="read" v-if="item.is_read == 0"></span>
						<p class="t1">{{item.title}}</p>
						<p class="t2">
							<span>发件人：{{item.send_name}}</span>
							<span>{{item.send_time}}</span>
						</p>
					</div>
				</li>
				<el-pagination
					background
					ref="pagination"
					@current-change="handleCurrentChange"
					:current-page="tableData.page | number"
					:page-size="tableData.pagesize | number"
					layout="total, prev, pager, next"
					:total="tableData.total | number">
				</el-pagination>
			</ul>
			<div v-else>
				暂无数据
			</div>
		</div>
		<div class="right box" style="display: none;">
			<div class="title">
				<span class="t1">公告</span>
				<span class="t2">查看更多<i class="el-icon-arrow-right"></i></span>
			</div>
			<ul class="notice">
				<li>
					<p>消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息</p>
					<span>2024-3-28</span>
				</li>
			</ul>
		</div>
	</div>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
		  loading:false,
		  tableData: {
		      total: 0,
		      pagesize: 20,
		      page: 1,
		      data: []
		  },
		  activeButtonIndex: 0,
		  buttons: [
			  { text: '全部' },
			  { text: '系统消息' },
			  { text: '审批提醒' },
			  { text: '业务提醒' }
		  ],
      }
	},
	computed: {
		
	},
	mounted: function () {
		this.handleSearch()
	},
	methods: {
		readAll(){
			this.$api.post('/admin/news/message/readall').then(res => {
				if (res.code === 0) {
				  this.handleSearch()
			  } else {
				 this.$message.error(res.msg);
			  }
			})
		},
		handleSearch: function (params, page, prop, order) {
		  this.loading = true;
		  var param = Object.assign({}, params);
		  param['page'] = page ? page : 1;
		  param['pagesize'] = this.tableData.pagesize;
		  if(this.activeButtonIndex > 0){
			  param.type = this.activeButtonIndex
		  }
		  this.$api.get('/admin/news/message/list',param).then(res => {
			  if (res.code === 0) {
				  this.tableData = res.data;
				  this.tableData.data.forEach((item,index) => {
					  if(item.send_name != '系统'){
						  this.$set(this.tableData.data[index],'send_name_jian',item.send_name.charAt(0))
					  }else{
						  this.$set(this.tableData.data[index],'send_name_jian',item.send_name)
					  }
				  })
				  this.loading = false
			  } else {
				 this.$message.error(res.msg);
			  }
			  this.loading = false
		  })
		},
		// 改变当前页 page
		handleCurrentChange(val) {
			this.handleSearch('', val);
		},
		toggleButton(index) {
		    this.activeButtonIndex = this.activeButtonIndex === index ? '' : index;
			this.handleSearch()
		},
		getButtonType(index) {
		    return this.activeButtonIndex === index ? 'primary' : '';
		},
		isButtonPlain(index) {
		    return this.activeButtonIndex === index;
		},
		getDetail(row){
			this.$api.get('/admin/news/message/info',{id:row.id}).then(res => {
			  if (res.code === 0) {
				  if(row.type == 2){
				  	this.$router.push({
				  		name: 'Checklist',
						query:{ type: row.status}
				  	});
				  }else{
					 this.$router.push({
					 	name: 'MessageDetail',
					 	query:{ id: row.id}
					 }); 
				  }
			  } else {
				 this.$message.error(res.msg);
			  }
			})
			// this.$api.get('/admin/news/message/info',{id:row.id}).then(res => {
			//   if (res.code === 0) {
			// 	  this.tableData.data.forEach((item,index) => {
			// 		  if(item.id == row.id){
			// 			  this.$set(this.tableData.data[index],'is_read',1)
			// 		  }
			// 	  })
			// 	  this.loading = false
			//   } else {
			// 	 this.$message.error(res.msg);
			//   }
			//   this.loading = false
			// })
		}
	}
}
</script>
<style lang="scss" scoped>
	.messageIndex{
		padding: 20px;
		box-sizing: border-box;
		display: flex;
		gap: 20px;
		.box{
			background-color: #fff;
			box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03);
			border-radius: 8px;
			min-height: 400px;
			padding: 20px;
			box-sizing: border-box;
		}
		.left{
			flex: 1;
			position: relative;
		}
		.right{
			width: 420px;
		}
		.title{
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding-bottom: 16px;
			margin-bottom: 16px;
			border-bottom: 1px solid #f0f0f0;
			.t1{
				color: #303133;
				font-size: 16px;
				font-weight: 600;
				display: flex;
				align-items: center;
				padding-left: 12px;
				position: relative;
				&::before{
					content: "";
					display: inline-block;
					width: 4px;
					height: 18px;
					background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
					border-radius: 2px;
					position: absolute;
					left: 0;
				}
			}
			.t2{
				font-size: 13px;
				color: #606266;
				cursor: pointer;
				display: flex;
				align-items: center;
				transition: color 0.2s ease;
				&:hover{
					color: #1e3c72;
				}
				.el-icon-arrow-right{
					margin-left: 4px;
					font-size: 12px;
				}
			}
		}
		.fenlei{
			display: flex;
			align-items: center;
			gap: 12px;
			padding-bottom: 16px;
			border-bottom: 1px solid #f5f5f5;
			margin-bottom: 16px;
			span{
				font-size: 13px;
				color: #606266;
			}
			.el-button{
				font-size: 12px;
				padding: 6px 16px;
			}
		}
		.con{
			max-height: calc(100vh - 320px);
			overflow-y: auto;
			padding-right: 8px;
			box-sizing: border-box;
			.el-pagination{
				position: sticky;
				bottom: 0;
				background: #fff;
				padding: 16px 0;
				margin-top: 16px;
				border-top: 1px solid #f5f5f5;
				display: flex;
				justify-content: flex-end;
			}
			li{
				display: flex;
				align-items: flex-start;
				padding: 14px 0;
				cursor: pointer;
				border-bottom: 1px solid #f5f5f5;
				transition: background-color 0.2s ease;
				&:hover{
					background-color: #fafafa;
				}
				&:last-child{
					border-bottom: none;
				}
				.name{
					width: 44px;
					height: 44px;
					background: #5E98FF;
					border-radius: 50%;
					display: inline-flex;
					align-items: center;
					justify-content: center;
					font-weight: 600;
					font-size: 18px;
					color: #FFFFFF;
					flex-shrink: 0;
					&.two{
						font-size: 13px;
					}
				}
				.content{
					flex: 1;
					margin-left: 14px;
					overflow: hidden;
					position: relative;
					.t1{
						font-weight: 500;
						font-size: 14px;
						color: #303133;
						line-height: 22px;
						height: 22px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						margin-bottom: 8px;
						padding-right: 24px;
					}
					.t2{
						font-weight: 400;
						font-size: 12px;
						color: #909399;
						line-height: 18px;
						display: flex;
						justify-content: space-between;
					}
					.read{
						width: 8px;
						height: 8px;
						background: #F56C6C;
						border-radius: 50%;
						position: absolute;
						right: 0;
						top: 6px;
					}
				}
			}
		}
		.notice{
			max-height: calc(100vh - 220px);
			overflow-y: auto;
			padding-right: 8px;
			box-sizing: border-box;
			li{
				display: flex;
				justify-content: space-between;
				height: 32px;
				align-items: center;
				p{
					font-weight: 500;
					font-size: 14px;
					color: #5A626B;
					height: 32px;
					line-height: 32px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					width:calc(100% - 80px);
					display: block;
				}
				span{
					font-weight: 500;
					font-size: 13px;
					color: #AAAAAA;
				}
			}
		}
		.fenlei{
			display: flex;
			align-items: center;
			padding: 20px 0;
			span{
				display: inline-flex;
				font-size: 14px;
				font-weight: bold;
				margin-right: 20px;
			}
		}
	}
</style>